import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation(['app']);
  const currentYear = new Date().getFullYear();
  
  return (
    <Box 
      component="footer" 
      sx={{  
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Box 
          sx={{ 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            {t('app:copyright', { year: currentYear })}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 